module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": "Muutosten ehdotus",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendData('form')
      }
    }
  }, [_c('p', [_c('strong', [_vm._v("Vahvista muutosehdotukset antamalla sähköpostisi. Tarvittaessa otamme sinuun yhteyttä.")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Sähköposti",
      "rules": [{
          required: true,
          message: 'Anna sähköpostiosoite',
          trigger: 'blur, submit'
        },
        {
          type: 'email',
          message: 'Anna toimiva sähköpostiosoite',
          trigger: 'blur, submit'
        }
      ]
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Peruuta")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sendData('form')
      }
    }
  }, [_vm._v("Lähetä")])], 1)], 1), _vm._v(" "), (!_vm.done) ? _c('div', [_c('search'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCompany),
      expression: "isCompany"
    }]
  }, [_c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.companyName))]), _vm._v(" "), (_vm.contacts && _vm.offices) ? _c('form', {
    attrs: {
      "id": "companyData"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitData()
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('contacts'), _vm._v(" "), _c('offices')], 1), _vm._v(" "), _c('input', {
    staticClass: "submit-btn",
    attrs: {
      "type": "submit",
      "value": "Lähetä muutosehdotukset"
    }
  })], 1) : _vm._e()])], 1) : _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Muutokset lähetetty")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-004664f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 448
// module chunks = 0